import $ from 'jquery';
import attachEnterAsClick from 'utils/attachEnterAsClick';
import resetTotalAllocation from 'utils/total-allocation';

const addSelector = '.dependant-item-add';

const dependantInit = (index, component) => {
    const $component = $(component);
    $component.find('.form-dependant-item').first().removeClass('is-hidden');

    $component.on('click', addSelector, () => {
        // find first dependant-item which is hidden
        const first = $component.find('.form-dependant-item.is-hidden').first();
        // make it visible
        first.removeClass('is-hidden');
        // move it to the end of the line
        $('.form-dependant-list').append(first);
        // check if there is no more dependant-items available to be showed
        if ($component.find('.form-dependant-item.is-hidden').length === 0) {
            $(addSelector).addClass('is-hidden');
        }
    });
    attachEnterAsClick($(addSelector));
};

const dependantTotalAllocation = (id, dependantParent) => {
    const allocationErrorMsg = 'Please update your allocations so they equal 100%.';
    const $error = $('<label>', { class: 'error error-msg', html: allocationErrorMsg });

    const $dependantId = $(`#${dependantParent}`);
    const value = $(`.${id}[type="number"]`);
    const display = $dependantId.find('span.total-allocation');
    const hidden = $dependantId.find('input.total-allocation');
    const intHidden = parseInt(hidden.val(), 10);
    const intValue = value.val() !== '' ? parseInt(value.val(), 10) : 0;
    const updatetotal = intHidden > 0 ? intHidden - intValue : 0;

    display.text(updatetotal);
    hidden.val(updatetotal);

    if (updatetotal < 100) {
        $dependantId.addClass('has-error');

        if ($dependantId.find('.error-msg').length < 1) {
            $dependantId.append($error);
        } else {
            $dependantId.find('label.error-msg').text(allocationErrorMsg);
        }
    }
};

const clearDependantForm = id => {
    $(`input.${id}, select.${id}`).val('');
    $(`input[type="radio"].${id}, input[type="checkbox"].${id}`).prop('checked', false);
};

const dependantId = act => {
    const $activeItem = $('.dependant-item-title').map((i, title) => {
        let item = null;
        const isHidden = $(title).parents('[data-dependant-id]').hasClass('is-hidden');

        if (act === 'add') {
            if (isHidden) {
                item = $(title).parents('[data-dependant-id]');
            }
        } else if (!isHidden) {
            item = $(title).parents('[data-dependant-id]');
        }

        return item;
    });

    return $activeItem;
};

const dependantItems = () => {
    const items = [];

    $('[id^="item-"]').each((i, item) => {
        const dependant = $(item).attr('id');

        if ($.inArray(dependant, items) === -1) {
            items.push(dependant);
        }
    });

    return items;
};

const dependantToggleInit = () => {
    // Hide dependant toggle on load
    // Show first dependant on load
    $.each(dependantItems(), (i, id) => {
        $(`[data-dependant-id=${id}]`).attr('data-hidden', true);

        if (i > 0) {
            $(`[data-dependant-id=${id}]`).addClass('is-hidden');
        } else {
            $(`[data-dependant-id=${id}]`).attr('data-hidden', false);
        }
    });
};

// Create dependant Form
const createDependantForm = () => {
    $.each(dependantItems().reverse(), (i, id) => {
        const $dependantForm = $('<div>', {
            class: 'dependant-form',
            'data-dependant-id': id,
            'data-hidden': true,
            'data-parent-checked': false
        });

        $dependantForm
            .insertAfter($('.item-0').parents('.ktc-default-section'));

        const $item = $(`.${id}`).parents('.ktc-default-section, .form-row').clone();
        const $clonedItem = $item.get().reverse();

        $(`.${id}`).parents('.ktc-default-section, .form-row').remove();
        $(`[data-dependant-id=${id}]`).append($clonedItem);
    });
};

const hideDependantToggle = id => {
    $(`[data-dependant-id=${id}]`).attr('data-parent-checked', false);
    $(`[data-dependant-id=${id}]`).attr('data-hidden', true);
};

const dependantItemClicks = $dependant => {
    let count = 1;
    const $removeDependant = $('.dependant-item-close');
    const dependantParent = $dependant.data('toggle');
    const $dependantOpt = $(`input.${dependantParent}-opt`);
    const dependantNomination = $dependantOpt.data('toggle');
    const $dependantForm = $('.dependant-form');
    const single = 'item-0';

    // Replicate level 1 options click
    $(`input.${dependantNomination}-opt`).on('click', e => {
        const nominateValue = $(e.currentTarget).val().toLowerCase();

        if (nominateValue === 'false') {
            $dependantForm.each((i, form) => {
                $(form).addClass('is-hidden');
            });

            $(`.${single}`).parents('.form-field').addClass('is-hidden');
            $(addSelector).addClass('is-hidden');

            // Reset all value and state on hidden
            $(addSelector).attr('data-parent-checked', false);
            $(addSelector).attr('data-hidden', true);
            resetTotalAllocation(dependantParent);
            clearDependantForm(single);

            $.each(dependantItems(), (i, id) => {
                clearDependantForm(id);
                hideDependantToggle(id);
            });
        }
    });

    // Replicate level 2 options click
    $dependantOpt.on('click', e => {
        const $opt = $(e.currentTarget);
        if ($opt.val() !== undefined) {
            if (!$opt.is(':checked')) { // inactive state
                if ($opt.data('val') === false) {
                    $.each(dependantItems(), (i, id) => {
                        dependantTotalAllocation(id, dependantParent);
                        clearDependantForm(id);

                        count = 1;

                        if (i > 0) {
                            $(`[data-dependant-id=${id}]`).addClass('is-hidden');
                        } else {
                            $(`[data-dependant-id=${id}]`).attr('data-hidden', false);
                        }
                    });

                    $dependantForm.attr('data-parent-checked', false);
                } else {
                    dependantTotalAllocation(single, dependantParent);
                    clearDependantForm(single);

                    $(`[data-toggle=${dependantParent}]`).attr('data-parent-checked', false);
                }
            } else if ($opt.data('val') === false) { // active state with value = false
                count = 1;

                // Reset to first order dependant
                const $firstOrderDependant = $($('[data-dependant-id]')[0]);
                $dependantForm.attr('data-parent-checked', true);
                $(addSelector).attr('data-parent-checked', true);
                $(addSelector).attr('data-hidden', false);
                $(addSelector).removeClass('is-hidden');

                // Show first order dependant
                $firstOrderDependant.removeClass('is-hidden');
                $firstOrderDependant
                    .find('.form-field, .form-row')
                    .removeClass('is-hidden');

                $firstOrderDependant.find('.dependant-item-title span').text(1);

                $('.dependant-item-add').parents('.form-field, .form-row').removeClass('is-hidden');
            } else {
                $(`[data-toggle=${dependantParent}]`).attr('data-parent-checked', true);
            }
        }

        // Set the siblings to True If one of the checkbox checked
        if ($(`input.${dependantParent}-opt:checked`).length > 0) {
            $dependantOpt.removeAttr('required');
            $dependantOpt
                .parents('.form-control, .form-field')
                .removeClass('error, has-error');

            $dependantOpt.siblings('.error-msg').hide();
        } else {
            $dependantOpt.attr('required', true);
            $dependantOpt.validate();
        }
    });

    $(addSelector).on('click', e => {
        e.preventDefault();

        count += 1;

        if (count <= (dependantItems().length)) {
            const dataId = dependantId('add')[0].data('dependant-id');
            const $addedDependant = $(`[data-dependant-id=${dataId}]`);

            $addedDependant
                .removeClass('is-hidden')
                .attr('data-hidden', false);

            $addedDependant
                .find('.form-row, .form-field')
                .removeClass('is-hidden');

            if (count === dependantItems().length) {
                $(e.target)
                    .parents('.form-row, .form-field')
                    .addClass('is-hidden');
            }
        }

        dependantId().each((i, active) => {
            $(active).find('.dependant-item-title span').text(i + 1);
        });
    });

    $removeDependant.on('click', e => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        const id = $this.attr('id');

        $(`[data-dependant-id=${id}]`)
            .addClass('is-hidden')
            .attr('data-hidden', true);

        const $getElement = $(`[data-dependant-id=${id}]`);

        $getElement.detach();
        $getElement.insertAfter($('[data-dependant-id]').last());

        $(addSelector)
            .parents('.form-row, .form-field')
            .removeClass('is-hidden');

        dependantId().each((i, active) => {
            $(active).find('.dependant-item-title span').text(i + 1);
        });

        dependantTotalAllocation(id, dependantParent);
        clearDependantForm(id);

        if (count > 0) {
            count -= 1;
        } else {
            count = 0;
        }
    });

    $dependantForm.find('input').on('input', e => {
        const parentClasses = '.form-field';
        const $target = $(e.currentTarget);
        const $targetLabel = $target.parents(parentClasses).find('.control-label');

        if ($target.val() !== '') {
            $targetLabel.addClass('filled');
        } else {
            $targetLabel.removeClass('filled');
        }
    });

    $dependantForm.find('select').on('change', e => {
        const parentClasses = '.form-row';
        const $target = $(e.currentTarget);
        const $targetLabel = $target.parents(parentClasses).prev().find('.control-label');
        if ($target.find('option:selected').val() !== '') {
            $targetLabel.addClass('filled');
        } else {
            $targetLabel.removeClass('filled');
        }
    });
};

$(() => {
    const $widget = $('.form-dependant');
    const $dependant = $('[data-toggle="beneficiary"]');

    if ($widget.length) {
        $widget.each(dependantInit);
    }

    if ($dependant.length) {
        createDependantForm();
        dependantToggleInit();
        dependantItemClicks($dependant);
    }
});
